var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommercial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 409.477 409.477",
    xmlSpace: "preserve",
    fill: "#ff8c08",
    stroke: "#ff8c08",
    strokeWidth: 3.275816,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M397.284,376.231h-12.193V53.519c0-24.621-18.232-44.658-40.643-44.658H232.68 c-22.41,0-40.643,20.037-40.643,44.658v59.265c-3.268-0.764-6.633-1.301-10.161-1.301H70.109 c-22.41,0-40.643,16.428-40.643,36.635v228.112H12.193C5.462,376.231,0,381.694,0,388.424s5.462,12.193,12.193,12.193h385.091 c6.73,0,12.193-5.462,12.193-12.193S404.015,376.231,397.284,376.231z M61.98,148.119c0-1.195,2.853-4.121,8.129-4.121h111.768 c5.275,0,8.129,2.918,8.129,4.121v228.112H61.98V148.119z M224.552,53.519c0-7.161,4.284-12.144,8.129-12.144h111.768 c3.845,0,8.129,4.983,8.129,12.144v322.713H224.552V53.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M268.812,55.12H248.71c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V66.89C280.582,60.387,275.307,55.12,268.812,55.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M268.812,112.02H248.71c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V123.79C280.582,117.287,275.307,112.02,268.812,112.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M268.812,168.92H248.71c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V180.69C280.582,174.187,275.307,168.92,268.812,168.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M328.419,55.12h-20.102c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V66.89C340.189,60.387,334.922,55.12,328.419,55.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M328.419,112.02h-20.102c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V123.79C340.189,117.287,334.922,112.02,328.419,112.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M328.419,168.92h-20.102c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V180.69C340.189,174.187,334.922,168.92,328.419,168.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M268.812,225.82H248.71c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V237.59C280.582,231.087,275.307,225.82,268.812,225.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M268.812,282.72H248.71c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V294.49C280.582,287.987,275.307,282.72,268.812,282.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M328.419,225.82h-20.102c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V237.59C340.189,231.087,334.922,225.82,328.419,225.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M328.419,282.72h-20.102c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V294.49C340.189,287.987,334.922,282.72,328.419,282.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M106.24,168.92H86.139c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V180.69C118.011,174.187,112.735,168.92,106.24,168.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M165.847,168.92h-20.102c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V180.69C177.617,174.187,172.35,168.92,165.847,168.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M106.24,225.82H86.139c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V237.59C118.011,231.087,112.735,225.82,106.24,225.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M106.24,282.72H86.139c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V294.49C118.011,287.987,112.735,282.72,106.24,282.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M165.847,225.82h-20.102c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V237.59C177.617,231.087,172.35,225.82,165.847,225.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c08"
    },
    d: "M165.847,282.72h-20.102c-6.495,0-11.77,5.267-11.77,11.77v20.102c0,6.495,5.267,11.77,11.77,11.77 h20.102c6.495,0,11.77-5.267,11.77-11.77V294.49C177.617,287.987,172.35,282.72,165.847,282.72z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercial);
export default __webpack_public_path__ + "static/media/commercial.994610c645181c41c36785c27d2955a0.svg";
export { ForwardRef as ReactComponent };